module.exports = __webpack_public_path__ + "power.svg?dc8f6512fe0589529fe92aa2ab871668";